import { Reducer } from "redux";
import { IQueuedNotificationState, QNotificationActionTypes } from "../types";
import { NotificationStatus } from "../../../common/sharedTypes";

// Type-safe initialState!
const initialState: IQueuedNotificationState = {
  notifications: [],
  notificationTypes: [],
  sentNotifications: [],
  pagedNotifications: [],
  pagedSentNotifications: [],
  totalNotifications: 0,
  loadingNotifications: false,
  totalSentNotifications: 0,
  loadingSentNotifications: false,
};

const reducer: Reducer<IQueuedNotificationState> = (state = initialState, action) => {
  //console.log('action', action);
  switch (action.type) {
    case QNotificationActionTypes.SET_PAGED_NOTIFICATIONS: {
      return { ...state, pagedNotifications: action.value };
    }
    case QNotificationActionTypes.SET_PAGED_SENT_NOTIFICATIONS: {
      return { ...state, pagedSentNotifications: action.value };
    }
    case QNotificationActionTypes.LOADING_NOTIFICATIONS: {
      return { ...state, loadingNotifications: action.value };
    }
    case QNotificationActionTypes.TOTAL_NOTIFICATIONS: {
      return { ...state, totalNotifications: action.value };
    }
    case QNotificationActionTypes.LOADING_SENT_NOTIFICATIONS: {
      return { ...state, loadingSentNotifications: action.value };
    }
    case QNotificationActionTypes.TOTAL_SENT_NOTIFICATIONS: {
      return { ...state, totalSentNotifications: action.value };
    }
    case QNotificationActionTypes.GET_QUEUED_NOTIFICATIONS_PAGED: {
      let _state = { ...state };
      _state = { ...state, pagedNotifications: action.value.notifications };
      _state = { ..._state, notificationTypes: action.value.notificationTypes };
      return _state;
    }
    case QNotificationActionTypes.GET_QUEUED_NOTIFICATIONS: {
      let _state = { ...state };
      _state = { ...state, notifications: action.value.notifications };
      _state = { ..._state, notificationTypes: action.value.notificationTypes };
      return _state;
    }
    case QNotificationActionTypes.REFRESH_SENT: {
      return {
        ...state,
        sentNotifications: [...state.sentNotifications, ...action.value],
      };
    }
    case QNotificationActionTypes.REFRESH_PAGED_SENT: {
      return {
        ...state,
        pagedSentNotifications: [...state.pagedSentNotifications, ...action.value],
      };
    }
    case QNotificationActionTypes.GET_SENT_NOTIFICATIONS: {
      return { ...state, sentNotifications: action.value.notifications };
    }
    case QNotificationActionTypes.REMOVE_PRINTED: {
      return {
        ...state,
        notifications: [...state.notifications.filter((x) => !action.value.includes(x.id))],
        pagedNotifications: [
          ...state.pagedNotifications.filter((x) => !action.value.includes(x.id)),
        ],
        totalNotifications: state.totalNotifications - action.value.length,
      };
    }
    case QNotificationActionTypes.UPDATE_NOTIFICATION: {
      //console.log('reduced', action);
      let _state = { ...state };
      _state.notifications = [
        ..._state.notifications.map((notification) =>
          notification.id == action.value.id ? { ...notification, ...action.value } : notification
        ),
      ];
      //console.log('fixed', _state.notifications);
      return _state;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
